import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import { EntityResultsPageTransport, UnitParamsTransport } from '../transports/entity-results-transport'

class ComboListingUnitClient {
    public getUnits({
        params,
        user,
    }: {
        user: RequestUserConfig
        params: UnitParamsTransport
    }): Promise<BaseTransport<EntityResultsPageTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: `/api/pages/v1/units-data?listingId=${params.listingId}&filter=${params.filter}&arrivalDate=${
                params.arrival
            }&departureDate=${params.departure}&adults=${params.adults}&childrenAges=${encodeURIComponent(
                params.childrenAges,
            )}&offset=${params.offset}`,
            headers,
        })
    }
}

export default new ComboListingUnitClient()
